import generatePayload from '@gov.wa.lni/application.warehouse-retaliation/source/data/payload.js';

export default (context, payload) => {
    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    const moduleId = context.getters.moduleId;
    const appState = context.rootState.appState;

    if (context.rootState[`${moduleId}_error-container`].errors.length > 0) {
        return;
    }

    context.commit('appState/SET_VALUE', {
        key: 'isLoading',
        value: true,
    }, {
        root: true,
    });

    const complaint = {
        list: context.rootState[`${moduleId}_complaint_complaint`].value,
        complaintDescription: context.rootState[`${moduleId}_complaint_description_input-text`].value,
        complaintDescribe: context.rootState[`${moduleId}_complaint_complaint-description_input-text`].value,
        outcomeDescription: context.rootState[`${moduleId}_complaint_outcome_input-text`].value,
        userFiledComplaint: context.rootState[`${moduleId}_other-agency`].value,
        agencyDetails: context.rootState[`${moduleId}_other-agency_details_input-text`].value ?? 'No Agency',
        dateFrom: context.rootState[`${moduleId}_complaint_start-date`].value,
        dateTo: context.rootState[`${moduleId}_complaint_end-date`].value,
        dateRange: `${context.rootState[`${moduleId}_complaint_end-date`].value} TO ${context.rootState[`${moduleId}_complaint_end-date`].value}`,
    };

    const contact = {
        firstName: context.rootState[`${moduleId}_contact_first-name`].value,
        lastName: context.rootState[`${moduleId}_contact_last-name`].value,
        phoneNumber: context.rootState[`${moduleId}_contact_phone-number_phone`].value,
        positionTitle: context.rootState[`${moduleId}_contact_position-title`].value,
        userLanguage: context.rootState[`${moduleId}_contact_preferred-language`].value,
        emailAddress: context.rootState[`${moduleId}_contact_email-address`].value,
        address1: context.rootState[`${moduleId}_contact_address_address1`].value,
        address2: context.rootState[`${moduleId}_contact_address_address2`].value,
        city: context.rootState[`${moduleId}_contact_address_city`].value,
        state: context.rootState[`${moduleId}_contact_address_state`].value,
        zip: context.rootState[`${moduleId}_contact_address_zip`].value,
        county: context.rootState[`${moduleId}_contact_address_county`].value ?? '40',
    };

    const employer = {
        dba: context.rootState[`${moduleId}_employer_name`].value,
        ubi: '',
        primaryPhone: context.rootState[`${moduleId}_employer_phone-number_phone`].value,
        primaryEmail: context.rootState[`${moduleId}_employer_email-address`].value,
        street1: context.rootState[`${moduleId}_employer_address_address1`].value,
        street2: context.rootState[`${moduleId}_employer_address_address2`].value,
        city: context.rootState[`${moduleId}_employer_address_city`].value,
        state: context.rootState[`${moduleId}_employer_address_state`].value,
        zip: context.rootState[`${moduleId}_employer_address_zip`].value,
        county: context.rootState[`${moduleId}_employer_address_county`].value ?? '40',
    };

    const certify = context.rootState[`retaliation-form_certify`].value;
    if (!employer) {
        appState.employer.county = appState.county;
    }
    const data = {
        complaint,
        contact,
        employer,
        certify,
    };

    setAttribute(context, 'appState', 'formData', data);

    const responseData = generatePayload(data, context);

    // Passing responseData to Aithent POST, receiving response.

    const config = payload.oneLni.environment.current.alisService;
    const endpoint = `${config.domain}/ALiSService/api/Complaint/SaveComplaint`;
    fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            // eslint-disable-next-line camelcase
            api_key: config.apiKey,
        },
        body: JSON.stringify(responseData),
    })
        .then(response => response.json())
        .then(result => {
            if (result.ComplaintNumber) {
                context.commit('appState/SET_VALUE', {
                    key: 'userData',
                    value: result.ComplaintNumber,
                }, {
                    root: true,
                });
                context.commit('appState/SET_VALUE', {
                    key: 'complaintNumber',
                    value: result.ComplaintNumber,
                }, {
                    root: true,
                });
                setAttribute(context, 'appState', 'hasFormData', true);
                setAttribute(context, 'appState', 'isInitialized', true);
                payload.router.push('/confirmation');
            } else if (result.ErrorList) {
                setAttribute(
                    context,
                    `${moduleId}_post-submission-errors`,
                    'items',
                    Object.keys(result.ErrorList).map(key => ({
                        level: 'Error',
                        message: result.ErrorList[key],
                    })),
                );
            }
        }).catch(() => {
            setAttribute(context, moduleId, 'displayFormError', true);
        });
};